import { render } from "./App.vue?vue&type=template&id=790fb160"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=790fb160&lang=less"

import exportComponent from "D:\\Tsubakimoto\\Tsubakimoto_mvc\\Tsubakimoto\\tsubakimoto_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__